(function () {
  function update(root, variantId) {
    const wrapper = root.querySelector('[data-delivery-time-wrapper]');
    if (!wrapper) return;

    const output = wrapper.querySelector('[data-delivery-time-text]');
    if (!output) return;

    const list = JSON.parse(wrapper.dataset.variantDeliveryTimes || '[]');
    const match = list.find(v => String(v.id) === String(variantId));

    output.textContent = match?.lieferzeit || '—';
  }

  function init(root) {
    const variantInput = root.querySelector('input[name="id"]');
    if (!variantInput) return;

    update(root, variantInput.value);

    root.addEventListener('change', () => {
      setTimeout(() => update(root, variantInput.value), 0);
    });

    root.addEventListener('variant:change', e => {
      if (e.detail?.variant?.id) {
        update(root, e.detail.variant.id);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    init(document);
  });
})();
